'use strict'

const SELECTORS = {
    element: '.js-read-more-wrp',
    text: '.js-read-more-text',
    toggle: '.js-read-more-toggler'
};

$(() => {
    $(document).on('click', SELECTORS.toggle, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).closest(SELECTORS.element).hasClass('cc-expanded')) {
            $(this).closest(SELECTORS.element).removeClass('cc-expanded');
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).closest(SELECTORS.element).addClass('cc-expanded');
            $(this).attr('aria-expanded', 'true');
        }
    });
});
